export default __webpack_public_path__ + "static/media/xmas_2023.f42727c0.jpg";